import { render, staticRenderFns } from "./Basketline.vue?vue&type=template&id=b47ad726&"
import script from "./Basketline.vue?vue&type=script&lang=js&"
export * from "./Basketline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports